export enum Theme {
  DARK = "dark",
  LIGHT = "light"
}

export enum Language {
  EN = "en",
  ZH = "zh"
}

export enum Currency {
  USD = "usd",
  CNY = "cny"
}

export enum Platform {
  MIXIN = "mixin",
  FOXONE = "foxone"
}

export enum Colors {
  RED = "#E23A3A",
  GREEN = "#009621",
  GRAY = "#959595",
  WARNING = "#FFC107"
}

export enum OrderSide {
  ASK = "ASK",
  BID = "BID"
}

export enum ColorStyle {
  GREEN_UP_RED_DOWN = "green_up_red_down",
  GREEN_DOWN_RED_UP = "green_down_red_up"
}

export type FusionProject = "wallet" | "defi" | "basis" | "trade" | "hfox";
